import { ArrowUpRight } from "lucide-react";
import PhotoSlot from "./PhotoSlot";
import { MaskedLine, Reveal } from "./motion";

export default function Creations() {
    return (
        <section
            id="creations"
            data-testid="category-creations"
            className="relative overflow-hidden py-24 sm:py-32"
        >
            <div className="pointer-events-none absolute left-[-10%] top-1/3 h-[50vh] w-[45vw] rounded-full bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.07),transparent_65%)]" />

            <div className="relative z-10 mx-auto grid max-w-[1500px] items-center gap-12 px-5 sm:px-10 lg:grid-cols-12 lg:gap-16">
                <div className="lg:col-span-4">
                    <Reveal>
                        <p className="font-mono-lux mb-6 flex items-center gap-4 text-[11px] tracking-[0.4em] text-[#D4AF37]">
                            <span className="inline-block h-px w-10 bg-[#D4AF37]/60" />
                            CRÉATIONS ARTISTIQUES
                        </p>
                    </Reveal>
                    <h2
                        data-testid="category-title-creations"
                        className="font-display text-3xl font-medium tracking-tight text-white sm:text-4xl lg:text-5xl"
                    >
                        <MaskedLine delay={0.1}>
                            <span className="text-gold-grad italic">
                                CRÉATIONS
                            </span>
                        </MaskedLine>
                    </h2>
                    <Reveal delay={0.25}>
                        <p className="font-display mt-6 text-xl font-light italic text-[#E2E2E2]/90 sm:text-2xl">
                            « Des images qui prennent une nouvelle dimension.
                            »
                        </p>
                        <div className="mt-7 flex items-center gap-3">
                            <span className="h-px w-16 bg-gradient-to-r from-[#D4AF37] to-transparent" />
                            <span className="h-1.5 w-1.5 rotate-45 bg-[#D4AF37]" />
                        </div>
                        <p className="mt-7 max-w-md text-base font-light leading-relaxed text-[#E2E2E2]/85 sm:text-lg">
                            Je crée également des compositions artistiques en
                            intégrant mes propres photographies dans de
                            grandes lettres et créations visuelles. Chaque
                            création est travaillée avec Photoshop afin de
                            donner une nouvelle dimension à mes images tout en
                            conservant l'essence de la photographie
                            originale.
                        </p>
                    </Reveal>
                </div>

                <div className="lg:col-span-8">
                    <Reveal delay={0.15} y={70}>
                        <PhotoSlot
                            image="/photo-creations.webp"
                            alt="Création artistique ART — grandes lettres 3D avec photographies intégrées, contour doré lumineux sur fond noir, par Daniel Dulude"
                            fit="contain"
                            ratio="aspect-[21/10]"
                            testId="photo-slot-creations"
                        />
                    </Reveal>
                    <Reveal delay={0.3}>
                        <div className="mt-10 flex justify-center">
                            <a
                                data-testid="creations-button"
                                href="https://danphotographemariage.gallery.aftershoot.com/collection/cr-ations-avec-lettres-et-personnages"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="group inline-flex items-center gap-3 border border-[#D4AF37] bg-gradient-to-r from-[#9A7B38] via-[#D4AF37] to-[#9A7B38] px-7 py-4 font-mono-lux text-[10px] tracking-[0.22em] text-[#050505] transition-all duration-500 hover:shadow-[0_0_45px_rgba(212,175,55,0.35)] sm:gap-4 sm:px-10 sm:text-xs sm:tracking-[0.3em]"
                            >
                                DÉCOUVRIR MES CRÉATIONS
                                <ArrowUpRight
                                    size={16}
                                    strokeWidth={1.6}
                                    className="transition-transform duration-500 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
                                />
                            </a>
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
